import React, {Component} from 'react';
import 'react-dropdown/style.css'
import './modal.css'
import '../../react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

const tabCharacter = "    ";
const fontItems = require('../../items/fontitems.json');
const fontnameItems = require('../../items/fontnameitems.json');
const aligmentItems = require('../../items/Alignment.json');
const dataTypeItems = require('../../items/DataType.json');

class ScriptProperties extends Component {
    render() {
        const formatStyle = {
            display: "block",
            marginLeft: 0,
            width: "360px",
            height: "80px",
            zIndex: "0",
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
        };
        return (
            <div>
                <table>
                    <tr>
                        <td valign={"top"} height={10} width={130}>
                            <div id="wb_Checkbox1">
                                <input type="checkbox" id="chkScript" name="" style={{display: "inline-block"}}
                                       onChange={e => this.props.onChangeIsScript(e)}
                                       defaultChecked={this.props.IsScript}/>
                                <label htmlFor="Checkbox1"
                                       style={{left: "60px"}, {float: "right"}, {position: "absolute"}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Embeded
                                    Script</label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td valign={"top"} height={90} width={130}>
                            {this.props.IsScript &&
                                <textarea name="TextArea1" id="TextArea1"
                                          ref={abc => this.child = abc}
                                          defaultValue={this.props.Script}
                                          onChange={e => this.props.onChangeScript(e)}
                                          style={formatStyle} rows="1" cols="20" spellCheck="false">
                </textarea>
                            }
                        </td>
                    </tr>
                </table>
            </div>
        );
    }
}

export default ScriptProperties;